export function parseBoolean(value: string | number | boolean | undefined): boolean {
    if (value === null || value === undefined) return false;
    // Handle boolean inputs directly
    if (typeof value === 'boolean') {
        return value;
    }

    // Handle number inputs
    if (typeof value === 'number') {
        return value !== 0;
    }

    // Handle string inputs
    if (typeof value === 'string') {
        const lowerValue = value.toLowerCase();

        if (lowerValue === 'true' || lowerValue === '1') {
            return true;
        }

        if (lowerValue === 'false' || lowerValue === '0') {
            return false;
        }

        // Optionally, throw an error if the string cannot be parsed as a boolean
        throw new Error(`Cannot parse string '${value}' to boolean`);
    }

    // If the type is not string, number, or boolean, throw an error
    throw new Error(`Unsupported type: ${typeof value}`);
}

export function currencyToDisplayPoints(value: number | null | undefined) {
    if (!value) return 'pts';
    return (currencyToPoints(value)).toLocaleString() + ' pts';
}

export function currencyToPoints(value: number | null | undefined) {
    return (value ?? 0) * 1.1;
}